import { url } from "../constants/apiUrl";
import Api from "./api";

class NoticeService extends Api {
  public api: Api;
  public URL = url.notice;

  constructor() {
    super();

    this.api = new Api();

    this.getNoticeList = this.getNoticeList.bind(this);
    this.getNoticeDetail = this.getNoticeDetail.bind(this);
  }

  getNoticeList({ page, poc, type }: { page?: any; poc?: any; type?: any }) {
    const param = {
      currentPage: !!page ? page : 1,
      poc: !!poc ? `${poc}` : "",
      type: !type
        ? ["notice", "e_notice", "update", "event", "etc"]
        : type.length > 0
        ? type
        : ["blank"],
    };
    try {
      return this.ajax("post", this.URL, "/list", param).then((res: any) => {
        return res.data;
      });
    } catch (e) {
      console.log(e);
    }
  }

  getNoticeDetail({ n_seq }: { n_seq?: number }) {
    try {
      return this.ajax("get", this.URL, `/${n_seq}`).then((res: any) => {
        return res.data;
      });
    } catch (e) {
      console.log(e);
    }
  }
}

export default new NoticeService();
